<a
  class="menu-link without-sub"
  [routerLink]="menu.url"
  routerLinkActive="active"
>
  @if (menu.icon?.length) {
  <span class="menu-icon">
    <app-keenicon [name]="menu.icon!" class="fs-2"></app-keenicon>
  </span>
  }@else {
  <span class="menu-bullet">
    <span class="bullet bullet-dot"></span>
  </span>
  }
  <span class="menu-title" [attr.data-link]="menu.url">{{
    menu.title | translate
  }}</span>
  <!-- <span class="menu-title" translate="MENU.DASHBOARD"></span> -->
</a>
